import { render, staticRenderFns } from "./VcfContactModal.vue?vue&type=template&id=42f55e8a&scoped=true&"
import script from "./VcfContactModal.vue?vue&type=script&lang=js&"
export * from "./VcfContactModal.vue?vue&type=script&lang=js&"
import style0 from "./VcfContactModal.vue?vue&type=style&index=0&id=42f55e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f55e8a",
  null
  
)

export default component.exports